<template>
  <div class="im-video-file-message">
    <video
      :id="message.payload.videoUUID"
      class="video"
      controls
      :src="message.payload.videoUrl"
      direction="0"
      @fullscreenchange="fullscreenchange"
    ></video>
    <div v-if="showProgress && percent" class="progress-wrap">
      <progress
        :percent="percent"
        class="progress"
        :show-info="true"
        active
        stroke-width="3"
        @activeend="onEnd"
      ></progress>
    </div>
    <div class="mask" @click.stop="onPlay" />
  </div>
</template>

<script>
export default {
  name: 'imVideoFileMessage',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      showProgress: true,
      videoContext: uni.createVideoContext(this.message.payload.videoUUID, this)
    }
  },
  methods: {
    onPlay() {
      this.videoContext.requestFullScreen()
      this.videoContext.play()
    },
    fullscreenchange(e) {
      if (!e.detail.fullScreen) {
        this.videoContext.stop()
      }
    },
    onEnd() {
      this.showProgress = false
    }
  }
}
</script>

<style lang="scss" scoped>
.im-video-file-message {
  position: relative;
  width: 9.813333rem;
  max-height: 9.813333rem;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;
  // overflow: hidden;

  .video {
    position: relative;
    display: block;
    object-fit: cover;
    width: 9.813333rem;
    height: 9.813333rem;
    z-index: 0;
  }

  .progress-wrap {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 0.853333rem;
    background: rgba(225, 225, 225, 0.5);
    z-index: 10;

    .progress {
      margin: 0 auto;
      height: 0.853333rem;
    }
  }

  .mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 80;
    background: transparent;
  }
}
</style>
